import Details from "../../../Shared/Components/Details";
import Attachments from "../../../Shared/Components/Attachments";
import Questionnaire from "./Questionnaire";
import ScheduleHistory from "./ScheduleHistory";
import { MeasuringTab } from "./MeasuringTab";

function navigationPages(ticket: any) {
  return [
    {
      key: "1",
      label: `Informações Gerais`.toUpperCase(),
      children: <Details />,
    },
    {
      key: "2",
      label: `Agendamentos e Histórico`.toUpperCase(),
      children: <ScheduleHistory ticket={ticket}/>,
    },
    {
      key: "3",
      label: `Ticket de Medição`.toUpperCase(),
      children: <MeasuringTab />,
    },
    {
      key: "4",
      label: `Questionários`.toUpperCase(),
      children: <Questionnaire />,
    },
    {
      key: "5",
      label: `Anexos`.toUpperCase(),
      children: <Attachments />,
    },
  ];
}

export default navigationPages;
